import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("gb_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401 && typeof window !== "undefined") {
            const path = window.location.pathname;
            const publicPaths = ["/", "/login", "/reklamation", "/kvittering", "/spor"];
            const isPublic = publicPaths.some((p) => path === p || path.startsWith(p + "/"));
            if (!isPublic) {
                localStorage.removeItem("gb_token");
                localStorage.removeItem("gb_user");
                window.location.href = "/login";
            }
        }
        return Promise.reject(error);
    },
);

export default api;
